import classNames from 'classnames';
import React, { FC, memo, ReactNode } from 'react';

import styles from './RadioLabel.styles.m.css';

interface IRadioLabelProps {
  className?: string;
  isActive: boolean;
  title: string | ReactNode;
  titleClassName?: string;
  value?: string | number;
  description?: string;
  descriptionClassName?: string;
  name?: string;
  onChange(): void;
}

export const RadioLabel: FC<IRadioLabelProps> = memo(
  ({
    className,
    isActive,
    value = '',
    title,
    titleClassName,
    description = '',
    descriptionClassName,
    onChange,
    name,
  }) => {
    const classes = classNames(styles.label, className, {
      [styles.active]: isActive,
    });

    return (
      <label className={classes}>
        <div className={styles.container}>
          <div className={styles.circle} />
          <input
            type="radio"
            className={styles.radio}
            value={value}
            name={name}
            onChange={onChange}
            checked={isActive}
          />
        </div>
        <div className={styles.block}>
          {title && <div className={classNames(styles.title, titleClassName)}>{title}</div>}
          {description && (
            <div className={classNames(styles.description, descriptionClassName)}>
              {description}
            </div>
          )}
        </div>
      </label>
    );
  }
);
